module.exports = __webpack_public_path__ + "static/ray-of-enfeeblement-mtg_afr-427377405735383666a1c41953e77397.jpg";